<script setup lang="ts">
/*
  A count on the corner of whatever it wraps: the user menu's avatar, with the number of
  invitations waiting. Nothing is drawn for zero, and past nine it says "9+" — an exact count of a
  long list is the list's job.

  Decorative. A pill read aloud on its own says "3" and nothing of what, so the control it sits on
  carries the number in its own accessible name (`nav.accountMenuPending`).
*/
import { computed } from "vue";

const props = defineProps<{ count: number }>();

const shown = computed(() => (props.count > 9 ? "9+" : String(props.count)));
</script>

<template>
	<span class="relative inline-flex">
		<slot />
		<span
			v-if="count > 0"
			aria-hidden="true"
			data-testid="count-badge"
			class="bg-accent text-accent-fg ring-surface pointer-events-none absolute -top-1 -right-1.5 flex h-4 min-w-4 items-center justify-center rounded-pill px-1 text-xxs leading-none font-medium tabular-nums ring-2"
		>
			{{ shown }}
		</span>
	</span>
</template>
